module.exports = __webpack_public_path__ + "static/holly-cam-zoom-edf8c2d8bb65852b657271375bd08750.jpg";